let en_US = {
    "CreateBusinessDocs": "CreateBusinessDocs",
    "MaintenanceAppointment": "MaintenanceAppointment",
    "Customer": "Customer",
    "Contact": "Contact",
    "Document Status": "Document Status",
    "Registered": "Registered",
    "Cancelled": "Cancelled",
    "Transferred": "Transferred",
    "AppointmentDocNo": "AppointmentDocNo",
    "ServiceType": "ServiceType",
    "Maintenance": "Maintenance",
    "Repair": "Repair",
    "SheetMetal": "SheetMetal",
    "SprayPaint": "SprayPaint",
    "PDI": "PDI",
    "VIN": "VIN",
    "CreationStartTime": "CreationStartTime",
    "CreationEndTime": "CreationEndTime",
    "Search": "Search",
    "Reset": "Reset",
    "SN": "SN",
    "Appointment Doc No.": "Appointment Doc No.",
    "Creation Time": "Creation Time",
    "Contact": "Contact",
    "Contact Number": "Contact Number",
    "Estimated Man-hours": "Estimated Man-hours",
    "Estimated Labor Cost": "Estimated Labor Cost",
    "Estimated Material Cost": "Estimated Material Cost",
    "Total Amount": "Total Amount",
    "Appointed Enter Time": "Appointed Enter Time",
    "Appointed Delivery Time": "Appointed Delivery Time",
    "Creator": "Creator",
    "Appointed Technicians": "Appointed Technicians",
    "Cancel Reason": "Cancel Reason",
    "Print Times": "Print Times",
    "Note": "Note",
    "Page Up": "Page Up",
    "Page Down": "Page Down",
    "Add": "Add",
    "Edit": "Edit",
    "View": "View",
    "Cancel": "Cancel",
    "Transfer to Maintenance": "Transfer to Maintenance",
    "Print": "Print",
    "New Appointment Doc": "New Appointment Doc",
    "Appointment Doc": "Appointment Doc",
    "Status": "Status",
    "Save": "Save",
    "Back": "Back",
    "Basic Info": "Basic Info",
    "Address": "Address",
    "License Plate": "License Plate",
    "Vehicle Model": "Vehicle Model",
    "Service Nature": "Service Nature",
    "Three Guarantees": "Three Guarantees",
    "Charge": "Charge",
    "Technician": "Technician",
    "Service Location": "Service Location",
    "In Station": "In Station",
    "On Scene": "On Scene",
    "Payment Type": "Payment Type",
    "On Credit": "On Credit",
    "Cash": "Cash",
    "Cheque": "Cheque",
    "Creation Time": "Creation Time",
    "Faults": "Faults",
    "Cancel Reason": "Cancel Reason",
    "Maintenance Schedule": "Maintenance Schedule",
    "Note": "Note",
    "Maintenance Item": "Maintenance Item",
    "Maintenance Material": "Maintenance Material",
    "Add Item": "Add Item",
    "Delete Item": "Delete Item",
    "Add Material": "Add Material",
    "Delete Material": "Delete Material",
    "SN": "SN",
    "Item Code": "Item Code",
    "Item": "Item",
    "Service Nature": "Service Nature",
    "Claim Unit": "Claim Unit",
    "Service Type": "Service Type",
    "Man-hours": "Man-hours",
    "Unit Price": "Unit Price",
    "Labor Cost": "Labor Cost",
    "Discount Rate": "Discount Rate",
    "Amount": "Amount",
    "Note": "Note",
    "Man-hours": "Man-hours",
    "Labor Cost": "Labor Cost",
    "Material Cost": "Material Cost",
    "Total Amount": "Total Amount",
    "Save": "Save",
    "Back": "Back",
    "Cancel Reason": "Cancel Reason",
    "Material Code": "Material Code",
    "Material Name": "Material Name",
    "Manufacturer Code": "Manufacturer Code",
    "Service Nature": "Service Nature",
    "Claim Unit": "Claim Unit",
    "Inventory": "Inventory",
    "Unit": "Unit",
    "Qty": "Qty",
    "Unit Price": "Unit Price",
    "Total": "Total",
    "Discount Rate": "Discount Rate",
    "Amount": "Amount",
    "Warehouse": "Warehouse",
    "Shelf": "Shelf",
    "Select Maintenance Item": "Select Maintenance Item",
    "Search": "Search",
    "Reset": "Reset",
    "Material Code": "Material Code",
    "Material Name": "Material Name",
    "Manufacturer Codes": "Manufacturer Codes",
    "Production Place": "Production Place",
    "Spec": "Spec",
    "Inventory": "Inventory",
    "Unit": "Unit",
    "Qty": "Qty",
    "Unit Price": "Unit Price",
    "Amount": "Amount",
    "Warehouse": "Warehouse",
    "Shelf": "Shelf",
    "Operation": "Operation",
    "Marketing Warehouse": "Marketing Warehouse",
    "Purchase, Sales and Inventory Details": "Purchase, Sales and Inventory Details",
    "Purchase History": "Purchase History",
    "Sales History": "Sales History",
    "Document  Type": "Document  Type",
    "Refresh": "Refresh",
    "This item is Required": "This item is Required",
    "Vehicle type": "Vehicle type",
    "More": "More>>",
    "Hide": "Hide",
    "Delete": "Delete",
    "Accessories brand": "Accessories brand",
    "Preferential amount": "Preferential amount",
    "taxation": "taxation",
    "Not yet": "Not yet",
    "Maintenance": "Maintenance",
    "Maintenance Doc No.": "Maintenance Doc No.",
    "Ex-warehoused": "Ex-warehoused",
    "Settled": "Settled",
    "Labor Cost": "Labor Cost",
    "Material Cost": "Material Cost",
    "Discount Amount": "Discount Amount",
    "Enter Time": "Enter Time",
    "Delivery Time": "Delivery Time",
    "Stock-out Time": "Stock-out Time",
    "Settle Time": "Settle Time",
    "Creator": "Creator",
    "Technician": "Technician",
    "Settle": "Settle",
    "Stock out": "Stock out",
    "Favorable Amount": "Favorable Amount",
    "turn": "turn",
    "Storekeeper": "Storekeeper",
    "Reckoner": "Reckoner",
    // 销售订单
    "Sales Order": "Sales Order",
    "Order Number": "Order Number",
    "Order Amount":"Order Amount",
    "Sales Order No.":"Sales Order No.",
    "Transfer Sales": "Transfer Sales",
    "Sales order transfer sales doc.":"Sales order transfer sales doc.",
    "Transfer sales doc. successful": "Transfer sales doc. successful",
    //配件销售
    "Material Sales": "Material Sales",
    "SN": "SN",
    "Sales Doc No.": "Sales Doc No.",
    "Status": "Status",
    "Creation Time": "Creation Time",
    "Customer": "Customer",
    "Contact": "Contact",
    "Contact Number": "Contact Number",
    "Sales Amount": "Sales Amount",
    "Discount Amount": "Discount Amount",
    "Receivable Amount": "Receivable Amount",
    "Payment Type": "Payment Type",
    "Creator": "Creator",
    "Storekeeper": "Storekeeper",
    "Stock-out Time": "Stock-out Time",
    "Reckoner": "Reckoner",
    "Settle Time": "Settle Time",
    "Add Sales Doc": "Add Sales Doc",
    "Sales Doc No.": "Sales Doc No.",
    "Status": "Status",
    "Address": "Address",
    "Payment Type": "Payment Type",
    "Creation Time": "Creation Time",
    "zero-suppression": "zero-suppression",
    "Customer Type": "Customer Type",
    "Personal Customer": "Personal Customer",
    "manufacturer Customer": "manufacturer Customer",
    "Group Customer": "Group Customer",
    "Major Customer": "Major Customer",
    "Note": "	Note",
    "Sales Details": "Sales Details",
    "Import Details": "Import Details",
    "Download template": "Download template",
    "Sales Qty": "Sales Qty",
    "Sales Amount": "Sales Amount",
    "Discount Amount": "Discount Amount",
    "Material Code": "Material Code",
    " Material Name": "Material Name",
    "Qty": "Qty",
    "Unit Price": "Unit Price",
    "Amount": "Amount",
    "Discount Rate": "Discount Rate",
    "Amount": "Amount",
    "Warehouse": "Warehouse",
    "Shelf": "Shelf",
    "Inventory": "Inventory",
    "Select Material": "Select Material",
    "Marketing Warehouse": "Marketing Warehouse",
    // 销售退货
    "Sales Return": "Sales Return",
    "Sales Return Doc No.": "Sales Return Doc No.",
    "Return Amount": "Return Amount",
    "Payment Type": "Payment Type",
    "Return Reason": "Return Reason",
    "Creator": "Creator",
    "Storekeeper": "Storekeeper",
    "Stock-in Time": "Stock-in Time",
    "Reckoner": "Reckoner",
    "Settle Time": "Settle Time",
    "Print Times": "Print Times",
    "Sales Return Docs": "Sales Return Docs",
    "Return Qty": "Return Qty",
    "Return Item Number": "Return Item Number",
    "Return Amount": "Return Amount",
    "Stock in": "Stock in",
    "Sales unit price": "Sales unit price",
    "Return unit price": "Return unit price",
    "Return Details": "Return Details",
    "Sales discount": "Sales discount",
    "Returned quantity": "Returned quantity",
    //采购入库
    "Purchase Management": "Purchase Management",
    "Purchase & Stock In": "Purchase & Stock In",
    "Supplier Name": "Supplier Name",
    "SN": "SN",
    "Purchase Doc No.": "Purchase Doc No.",
    "Supplier Name": "Supplier Name",
    "Contact": "Contact",
    "Contact Number": "Contact Number",
    "Purchase Qty": "Purchase Qty",
    "Purchase Amount": "Purchase Amount",
    "Creator": "Creator",
    "Storekeeper": "Storekeeper",
    "Stock-in Time": "Stock-in Time",
    "Reckoner": "Reckoner",
    "Settle Time": "Settle Time",
    "Purchase Doc": "Purchase Doc",
    "Purchase Doc No.": "Purchase Doc No.",
    "Stock in": "Stock in",
    "Supplier Type": "Supplier Type",
    "Purchase Details": "Purchase Details",
    "Download Template": "Download Template",
    "Material Brand": "Material Brand",
    "Purchase Qty": "Purchase Qty",
    "Unit Price": "Unit Price",
    "Purchase Amount": "Purchase Amount",
    "Purchase Item Number": "Purchase Item Number",
    // 采购退货
    "Purchase Return": "Purchase Return",
    "Purchase Return Doc No.": "Purchase Return Doc No.",
    "Purchase Return Doc": "Purchase Return Doc",
    "Return Qty": "Return Qty",
    "Return Amount": "Return Amount",
    "Add Purchase Return Doc": "Add Purchase Return Doc",
    "Supplier Type": "Supplier Type",
    "Return Qty": "Return Qty",
    "Unit Price": "Unit Price",
    "Return Amount": "Return Amount",
    "Return Item Number": "Return Item Number",
    "Mining and return details": "Mining and return details",
    //库存统计
    "Warehouse Management": "Warehouse Management",
    "Inventory Statistics": "Inventory Statistics",
    "Warehouse Managements": "Warehouse Management",
    "Shelf": "Shelf",
    "Only show available": "Only show available",
    "Material Type": "Material Type",
    "Material Brand": "Material Brand",
    "Spec&Model": "Spec&Model",
    "Qty in Stock": "Qty in Stock",
    "Latest Purchase Price": "Latest Purchase Price",
    "Latest Retail Price": "Latest Retail Price",
    "Latest Inventory Cost": "Latest Inventory Cost",
    "Shortage Qty": "Shortage Qty",
    "Redundant Qty": "Redundant Qty",
    "Average Purchase Price": "Average Purchase Price",
    "Average Inventory Cost": "Average Inventory Cost",
    "Qty in Stock": "Qty in Stock",
    "Species Number in Stock": "Species Number in Stock",
    "Upper Limit": "Upper Limit",
    "Lower Limit": "Lower Limit",
    "Outbound order": "Outbound order",
    "Stock in order": "Stock in order",
    "Statistics Details": "Statistics Details",
    "Stock-io Type": "Stock-io Type",
    "Document  Type": "Document  Type",
    "Document No.": "Document No.",
    "Qty": "Qty",
    "Unit Price": "Unit Price",
    "Amount": "Amount",
    //库存盘点
    "Stocktaking": "Stocktaking",
    "Stocktaking Doc No.": "Stocktaking Doc No.",
    "Stocktaking status": "Stocktaking status",
    "Result": "Result",
    "Stocktaking Surplus Doc": "Stocktaking Surplus Doc",
    "Stocktaking Loss Doc": "Stocktaking Loss Doc",
    "SN": "SN",
    "Stocktaking Time": "Stocktaking Time",
    "underway": "underway",
    "Finished": "Finished",
    "Cancelled": "Cancelled",
    "Document  Type": "Document  Type",
    "initialization Doc": "initialization Doc",
    "Stocktaking Doc No.": "Stocktaking Doc No.",
    "System Inventory": "System Inventory",
    "Stocktaking Inventory": "Stocktaking Inventory",
    "Stocktaking Surplus Qty": "Stocktaking Surplus Qty",
    "Stocktaking Loss Qty": "Stocktaking Loss Qty",
    "Result": "Result",
    "Creator": "Creator",
    "Note": "Note",
    "Add  Stocktaking Doc": "Add  Stocktaking Doc",
    "Stocktaking Doc No.": "Stocktaking Doc No.",
    "Finish": "Finish",
    "Start Time": "Start Time",
    "End Time": "End Time",
    "Stocktaking Details": "Stocktaking Details",
    "Difference Qty": "Difference Qty",
    "Difference Amount": "Difference Amount",
    "System Inventory": "System Inventory",
    "Real Inventory": "Real Inventory",
    "Surplus Item Number": "Surplus Item Number",
    "Loss Item Number": "Loss Item Number",
    "Difference Qty": "Difference Qty",
    "Difference Amount": "Difference Amount",
    "Difference Rate": "Difference Rate",
    "Stocktaking Doc": "Stocktaking Doc",
    "Stocktaking  Type": "Stocktaking  Type",
    "Stocktaking Num": "Stocktaking Num",
    //出库单据
    "Stock Out": "Stock Out",
    "Stock-out Doc No.": "Stock-out Doc No.",
    "Document  Type": "Document  Type",
    "Material Code": "Material Code",
    "Stock-out Qty": "Stock-out Qty",
    "Stock-out Time": "Stock-out Time",
    "Creator": "Creator",
    "Creation Time": "Creation Time",
    "Stock-out Doc Number": "Stock-out Doc Number",
    //入库单据
    "Stock In": "Stock In",
    "Stock In Doc No.": "Stock In Doc No.",
    "Stock-in Qty": "Stock-in Qty",
    "Stock-in Doc Number": "Stock-in Doc Number",
    "Stock-in Time": "Stock-in Time",
    //供应商档案
    "Basic Data": "Basic Data",
    "Supplier Management": "Supplier Management",
    "Supplier Code": "Supplier Code",
    "Supplier Name": "Supplier Name",
    "Supplier Type": "Supplier Type",
    "Supplier": "Supplier",
    "Supplier Details": "Supplier Details",
    "Basic Info": "Basic Info",
    "Contact": "Contact",
    "Contact Number": "Contact Number",
    "Email": "Email",
    "Office Tel": "Office Tel",
    "Address": "Address",
    "Postcode": "Postcode",
    "Note": "Note",
    "open": "open",
    "close": "close",
    "Import": "Import",
    "Record Time": "Record Time",
    "Billing information": "Billing information",
    "Invoice title": "Invoice title",
    "Business license": "Business license",
    "Invoice Info": "Invoice Info",
    "Invoice Title": "Invoice Title",
    "Business License": "Business License",
    "Bank": "Bank",
    "Bank Account": "Bank",
    "Mailing Address": "Mailing Address",
    "Legal Person": "Legal Person",
    "Other Info": "Other Info",
    "Founder": "Founder",
    "Founder Time": "Founder Time",
    "Updater": "Updater",
    "Update Time": "Update Time",
    //配件管理
    "Material Management": "Material Management",
    "Replace Code": "Replace Code",
    "Material Status": "Material Status",
    "Material Code": "Material Code",
    "Material Type": "Material Type",
    "Spec&Model": "Spec&Model",
    "Production Place": "Production Place",
    "Upper Limit": "Upper Limit",
    "Lower Limit": "Lower Limit",
    "Purchase Price": "Purchase Price",
    "Retail Price": "Retail Price",
    "Warehouse": "Warehouse",
    "Shelf": "Shelf",
    "Inventory information": "Inventory information",
    "Material Price": "Material Price",
    "Material Details": "Material Details",
    //仓库管理
    "Warehouse Settings": "Warehouse Settings",
    "Warehouse Code": "Warehouse Code",
    "Warehouse Name": "Warehouse Name",
    "Warehouse Type": "Warehouse Type",
    "Shelf Code": "Shelf Code",
    "Warehouse": "Warehouse",
    "Prefix": "Prefix",
    "Start Code": "Start Code",
    "New Warehouse": "New Warehouse",
    "New Shelf": "New Shelf",
    "Total Qty of Warehouse Shelf": "Total Qty of Warehouse Shelf",
    "Warehouse Details": "Warehouse Details",
    "Shelf Information": "Shelf Information",
    "Batch entry": "Batch entry",
    // 客户管里
    "Customer Management": "Customer Management",
    "Subordinate Vehicle": "Subordinate Vehicle",
    "Customer": "Customer",
    "Customer Type": "Customer Type",
    "Address": "Address",
    "Operation": "Operation",
    "Enable": "Enable",
    "Disable": "Disable",
    "Add Customer": "Add Customer",
    "Edit Customer": "Edit Customer",
    "Customer Details": "Customer Details",
    "Reset": "Reset",
    "Customer Code": "Customer Code",
    "Email": "Email",
    "Office Tel": "Office Tel",
    "Record Time": "Record Time",
    "Postcode": "Postcode",
    "Note": "Note",
    "Customer Status": "Customer Status",
    "Invoice Info": "Invoice Info",
    "Invoice Title": "Invoice Title",
    "Business License": "Business License",
    "Bank": "Bank",
    "Bank Account": "Bank Account",
    "Legal Person": "Legal Person",
    "Business Scope": "Business Scope",
    "Other Info	": "Other Info",
    "Updater": "Updater",
    "Update Time": "Update Time",
    //车辆信息
    "Vehicle Management": "Vehicle Management",
    "License Plate": "License Plate",
    "Vehicle Type": "Vehicle Type",
    "VIN": "VIN",
    "Engine No.": "Engine No.",
    "Creation Time": "Creation Time",
    "Vehicle Code": "Vehicle Code",
    "Vehicle Model": "Vehicle Model",
    "Creator": "Creator",
    "Delivery Time": "Delivery Time",
    "Record Time": "Record Time",
    "Using Property": "Using Property",
    "Vehicle Status": "Vehicle Status",
    "Back to Customer": "Back to Customer",
    "Add Vehicle": "Add Vehicle",
    "Edit Vehicle": "Edit Vehicle",
    "Vehicle Details": "Vehicle Details",
    // 维修项目
    "Maintenance Items": "Maintenance Items",
    "Item Code": "Item Code",
    "Item": "Item",
    "Man-hours": "Man-hours",
    "Unit Price": "Unit Price",
    "Labor Cost": "Labor Cost",
    "New Maintenance Item": "New Maintenance Item",
    "Edit Maintenance Item": "Edit Maintenance Item",
    "Item Details": "Item Details",
    "Basic Info": "Basic Info",
    "Service Type": "Service Type",
    "Maintenance": "Maintenance",
    "Repair": "Repair",
    "Sheet Metal": "Sheet Metal",
    "Spray Paint": "Spray Paint",
    "PDI": "PDI",
    //维修技师
    "Technician Management": "Technician Management",
    "New Technician": "New Technician",
    "Edit Technician": "Edit Technician",
    "Name": "Name",
    "Phone": "Phone",
    "Post": "Post",
    "Assigned Points": "Assigned Points",
    //角色设置
    "System Settings": "System Settings",
    "Character Settings": "Character Settings",
    "Character Name": "Character Name",
    "Character Code": "Character Code",
    "Character Description": "Character Description",
    "Note": "Note",
    "Operation": "Operation",
    //员工设置
    "Employee Settings": "Employee Settings",
    "Employee": "Employee",
    "Contact Number": "Contact Number",
    "Employee Account": "Employee Account",
    "Account Password": "Account Password",
    "Address": "Address",
    " Email": "Email",
    "Post": "Post",
    "System Role": "System Role",
    "Creator": "Creator",
    "Storekeeper": "Storekeeper",
    "Reckoner": "	Reckoner",
    "Technician": "Technician",
    "Person in Charge": "	Person in Charge",
    "Add Employee": "Add Employee",
    "Edit Employee": "Edit Employee",
    "View Employee": "View Employee",
    //数据字典
    "Add subordinates": "Add subordinates",
    "Add sibling": "Add sibling",
    "cancel": "cancel",
    "Local Save": "Local Save",
    "Data dictionary": "Data dictionary",
    "PCode": "PCode",
    "Code": "Code",
    "NamesEn": "NamesEn",
    "Names": "Names",
    "Select the parent field you want to add.": "Select the parent field you want to add.",
    "Enable mode of adding subordinate field.": "Enable mode of adding subordinate field.",
    "Select the brother field you want to add.": "Select the brother field you want to add.",
    "Enable mode of adding brother field.": "Enable mode of adding brother field.",
    "Please select the node to delete.": "Please select the node to delete.",
    "Business Process Diagram": "Business Process Diagram",
    "Functional distribution diagram": "Functional distribution diagram",

    //通用message提示字段
    "Please select a single piece of data for editing.": "Please select a single piece of data for editing.",//"请选择单条数据进行编辑",
    "The document is invalid and cannot be edited.": "The document is invalid and cannot be edited.",//"该单据已作废，无法进行编辑",
    "Jump to the detail page of maintenance doc.": "Jump to the detail page of maintenance doc.",//"维修单跳转详情",
    "The detail page of maintenance doc has not been saved. Do you still want to jump?": "The detail page of maintenance doc has not been saved. Do you still want to jump?",//"您还有维修单详情未保存，是否跳转",
    "Jump to the unsaved page": "Jump to the unsaved page",//"跳转未保存页",
    "Open a new page": "Open a new page",//"打开新页签",
    "Please select a single piece of data to view.": "Please select a single piece of data to view.",//"请选择单条数据进行查看",
    "Please select a single piece of data for cancellation.": "Please select a single piece of data for cancellation.",//"请选择单条数据进行作废",
    "Successfully transferred to maintenance doc": "Successfully transferred to maintenance doc",//"转维修单成功",
    "Unsuccessfully transferred to maintenance doc": "Unsuccessfully transferred to maintenance doc",//"转维修单失败",
    "Successfully added": "Successfully added",//"新增成功",
    "Successfully edited": "Successfully edited",//"编辑成功",
    "Successfully refreshed": "Successfully refreshed",//"刷新成功",
    "Selected  Qty ≥ Stock Qty": "Selected  Qty ≥ Stock Qty",//"选择数量≥库存数量",
    "Maintenance Appointment - Select Items": "Maintenance Appointment - Select Items",//"维修预约-选择项目",
    "List of items to be selected": "List of items to be selected",//"待选项目列表",
    "List of selected items": "List of selected items",//"已选项目列表",
    "Material Brand": "Material Brand",//"配件品牌",
    "List of materials to be selected": "List of materials to be selected",//"待选配件列表",
    "List of selected materials": "List of selected materials",//"已选配件列表",
    "Maintenance Appointment - Select Materials": "Maintenance Appointment - Select Materials",// "维修预约-选择用料",
    "Discount Amount": "Discount Amount",//"优惠金额",
    "Taxes": "Taxes",// "税费",
    "Successfully settled": "Successfully settled",// "结算成功",
    "Unsuccessfully settled": "Unsuccessfully settled",// "结算失败",
    "Successfully stocked out": "Successfully stocked out",// "出库成功",
    "Unsuccessfully stocked out": "Unsuccessfully stocked out",// "出库失败",
    "The maintenance doc": "The maintenance doc",// "该维修单",
    "cannot be edited again.": "cannot be edited again.",// "无法在进行编辑操作",
    "Successfully deleted": "Successfully deleted",// "删除成功",
    "Unsuccessfully deleted": "Unsuccessfully deleted",// "删除失败",
    "The item name of": "The item name of",// "项目名称：",
    "is repeated and will not be added.": "is repeated and will not be added.",//"，重复的将不在添加。",
    "The material name of": "The material name of",// "物料名称：",
    "The customer does not have a vehicle. Click the license plate field on the left to add a new one.": "The customer does not have a vehicle. Click the license plate field on the left to add a new one.",// "该客户下没有车辆，点击左侧车辆牌照去新增吧",
    "The document has been settled and cannot be edited.": "The document has been settled and cannot be edited.",// "该单据已结算，无法进行编辑",
    "The document has been stocked out and cannot be edited.": "The document has been stocked out and cannot be edited.",//"该单据已出库，无法进行编辑",
    "The document has been cancelled and cannot be edited.": "The document has been cancelled and cannot be edited.",// "该单据已作废，无法进行编辑",
    "Cancel the maintenance doc.": "Cancel the maintenance doc.",//"维修单作废",
    "Settle the maintenance doc.": "Settle the maintenance doc.",//"维修单结算",
    "Stock out the maintenance doc.": "Stock out the maintenance doc.",// "维修单出库",
    "The current number is invalid.": "The current number is invalid.",// "当前不是一个有效数字",
    "Sales Qty ≥ Inventory Qty": "Sales Qty ≥ Inventory Qty",//"销售数量≥库存数量",
    "Sales Doc -Select Materials": "Sales Doc -Select Materials",//"销售单-选择配件",
    "Sales Order Doc -Select Materials": "Sales Order Doc -Select Materials",
    "Jump to the detail page of sales return doc.": "Jump to the detail page of sales return doc.",// "销售退货单跳转详情",
    "The detail page of sales return doc has not been saved. Do you still want to jump?": "The detail page of sales return doc has not been saved. Do you still want to jump?",// "您还有销售退货单详情未保存，是否跳转",
    "Cancel the sales return doc.": "Cancel the sales return doc.",// "销售退货单作废",
    "Stock in the sales return doc.": "Stock in the sales return doc.",// "销售退货单入库",
    "Settle the sales return doc.": "Settle the sales return doc.",// "销售退货单结算",
    "Sales Unit Price": "Sales Unit Price",// "销售单价",
    "Return Unit Price": "Return Unit Price",//"退货单价",
    "Sales Return Qty ≥ Sales Qty - Returned Qty, return qty should be less than": "Sales Return Qty ≥ Sales Qty - Returned Qty, return qty should be less than",// "销售退货数量≥销售数量-已退数量 ,退货数量应小于",
    "Sales Return Qty ≥ Sales Qty - Returned Qty": "Sales Return Qty ≥ Sales Qty - Returned Qty",// "销售退货数量≥销售数量-已退数量",
    "Sales Discount": "Sales Discount",// "销售折扣",
    "Sales Return Doc -Select Materials": "Sales Return Doc -Select Materials",//"销售退货单-选择配件",
    "Purchase Doc -Select Materials": "Purchase Doc -Select Materials",//"采购单-选择配件",
    "Purchase Return Doc -Select Materials": "Purchase Return Doc -Select Materials",// "采购退货单-选择配件",
    "Purchase Return Details": "Purchase Return Details",// "采退明细",
    "Return Qty ≥ Purchase Qty + Returned Qty": "Return Qty ≥ Purchase Qty + Returned Qty",//"退货数量≥采购数量+已退数量",
    "Type of Stock-io": "Type of Stock-io",// "出入类型",
    "Document No.": "Document No.",//"单据编号",
    "Surplus": "Surplus",//"盘盈",
    "Loss": "Loss",//"盘亏",
    "Equal": "Equal",// "相符",
    "The document has been completed and cannot be operated again.": "The document has been completed and cannot be operated again.",// "单据已完成，无法再次盘点",
    "Stocktaking failed.": "Stocktaking failed.",// "盘点失败",
    "Stocktaking succeeded.": "Stocktaking succeeded.",// "盘点成功",
    "Average Purchase Price": "Average Purchase Price",// "平均进货价",
    "Lastest Sales Price": "Lastest Sales Price",//"最近销售价",
    "Qty Difference Rate": "Qty Difference Rate",//"数量差异率",
    "Amount Difference Rate": "Amount Difference Rate",//"金额差异率",
    "The supplier is added successfully.": "The supplier is added successfully.",// "供应商新增成功",
    "The supplier is added unsuccessfully.": "The supplier is added unsuccessfully.",//"供应商新增失败",
    "The supplier is edited successfully.": "The supplier is edited successfully.",// "供应商编辑成功",
    "The supplier is edited unsuccessfully.": "The supplier is edited unsuccessfully.",// "供应商编辑失败",
    "Successfully imported": "Successfully imported",// "导入成功",
    "Unsuccessfully imported": "Unsuccessfully imported",// "导入失败",
    "Inventory Information": "Inventory Information",// "库存信息",
    "Please enter a numeric type. Two decimal digits can be reserved.": "Please enter a numeric type. Two decimal digits can be reserved.",//"请输入数值类型,可保留二位位小数",
    "title": "title",
    "Yes No": "Yes No",
    "Please enter your reason for cancellation": "Please enter your reason for cancellation",
    "Select Materials": "Select Materials",
    "Select Items": "Select Items",
    "Jump to the detail page of Sales doc.": "Jump to the detail page of Sales doc.",
    "The detail page of Sales doc has not been saved. Do you still want to jump?": "The detail page of Sales doc has not been saved. Do you still want to jump?",
    "Cancel the Sales doc.": "Cancel the Sales doc.",
    "Settle the Sales doc.": "Settle the Sales doc",
    "Stock out the Sales doc.": "Stock out the Sales doc.",
    "Please add material details.": "Please add material details.",
    "Successfully stocked in": "Successfully stocked in",
    "Unsuccessfully stocked in": "Unsuccessfully stocked in",
    "The document has been stocked in and cannot be edited.": "The document has been stocked in and cannot be edited.",
    "Jump to the detail page of Purchase doc.": "Jump to the detail page of Purchase doc.",
    "The detail page of Purchase doc has not been saved. Do you still want to jump?": "The detail page of Purchase doc has not been saved. Do you still want to jump?",
    "Cancel the Purchase doc.": "Cancel the Purchase doc.",
    "Settle the Purchase doc.": "Settle the Purchase doc.",
    "Stock in the Purchase doc.": "Stock in the Purchase doc.",
    "Jump to the detail page of Purchase Return doc.": "Jump to the detail page of Purchase Return doc.",
    "The detail page of Purchase Return doc has not been saved. Do you still want to jump?": "The detail page of Purchase Return doc has not been saved. Do you still want to jump?",
    "Cancel the Purchase Return doc.": "Cancel the Purchase Return doc.",
    "Settle the Purchase Return doc.": "Settle the Purchase Return doc.",
    "Stock out the Purchase Return doc.": "Stock out the Purchase Return doc.",
    "There is no data in the purchase return detail, please add it quickly.": "There is no data in the purchase return detail, please add it quickly.",
    "Jump to the detail page of stocktaking doc.": "Jump to the detail page of stocktaking doc.",
    "The detail page of stocktaking doc has not been saved. Do you still want to jump?": "The detail page of stocktaking doc has not been saved. Do you still want to jump?",
    "Cancel the stocktaking doc.": "Cancel the stocktaking doc.",
    "Unsuccessfully edited": "Unsuccessfully edited",
    "Unsuccessfully added": "Unsuccessfully added",
    "Jump to the detail page": "Jump to the detail page",
    "The detail page has not been saved. Do you still want to jump?": "The detail page has not been saved. Do you still want to jump?",
    "New shelf has been successfully added.": "New shelf has been successfully added.",
    "New shelf has been unsuccessfully added.": "New shelf has been unsuccessfully added.",
    "New data dic has been successfully added.": "New data dic has been successfully added.",
    "New data dic has been successfully edited.": "New data dic has been successfully edited.",
    "New data dic has been successfully deleted.": "New data dic has been successfully deleted.",
    "The code is required.": "The code is required.",
    "ItemEn": "ItemEn",
    "Material Name En": "Material Name En",
    "day": "day",
    "month": "month",
    "week": "week",
    "onOk": "onOk",
    "Confirm printing": "Confirm printing",
    "Settings": "Settings",
    "export": "export",
    "Details export": "Details export",
    "List export": "List export",
    "Statistic Analysis": "Statistic Analysis",
    "Stock-io  List": "Stock-io  List",
    "Stock-io Type": "Stock-io Type",
    "Stock out": "Stock out",
    "Stock in": "Stock in",
    "Document  Type": "Document  Type",
    "Sales Docs": "Sales Docs",
    "Maintenance Docs": "Maintenance Docs",
    "Sales Return Docs": "Sales Return Docs",
    "Purchase Docs": "Purchase Docs",
    "Purchase Return Docs": "Purchase Return Docs",
    "Stock-io Time": "Stock-io Time",
    "Material Code": "Material Code",
    "Material Name": "Material Name",
    "Qty": "Qty",
    "Unit Price": "Unit Price",
    "Amount": "Amount",
    "Payment Method": "Payment Method",
    "Creator": "Creator",
    "Storekeeper": "Storekeeper",
    "Reckoner": "Reckoner",
    "Stock-out Qty": "Stock-out Qty",
    "Stock-out Amount": "Stock-out Amount",
    "Stock-in Qty": "Stock-in Qty",
    "Stock-in Amount": "Stock-in Amount",
    "Technician Performance": "Technician Performance",// "技师业绩",
    "Technician": "Technician",// "维修人员",
    "Maintenance Vehicle- times": "Maintenance Vehicle- times",// "维修台次",
    "Total Man-hours": "Total Man-hours",// "总工时数",
    "Labor Cost": "Labor Cost",// "工时费",
    "Percentage": "Percentage",//"提成",
    "Maintenance Man-hours": "Maintenance Man-hours",// "维修工时",
    "Total　Labor Cost": "Total　Labor Cost",// "工时费合计",
    "Receivable Amount": "Receivable Amount",// "应收统计",,
    "Document  Type": "Document  Type",// "单据类型",
    "Customer": "Customer",//"客户名称",
    "Customer Attribute": "Customer Attribute",// "客户属性",
    "Customer": "Customer",// "客户",
    "Supplier": "Supplier",// "供应商",
    "Receivable Amounts": "Receivable Amounts",// "应收金额",
    "Creator": "Creator",//"制单人",
    "Creation Time": "Creation Time",// "制单时间",
    "Total Payable Amount": "Total Payable Amount",// "应付统计",
    "Payable Amount": "Payable Amount",//"应付金额",
    "Turnover": "Turnover",// "营业额",
    "Receivable Amount": "Receivable Amount",// "应收金额",
    "Received Amount": "Received Amount",// "已收金额",
    "Sales Volume": "Sales Volume",
    "Maintenance Volume": "Maintenance Volume",// "维修额",
    "Material Cost": "Material Cost",// "零件费",
    "Total Labor Cost": "Total Labor Cost",// "工时费合计",
    "Total Material Cost": "Total Material Cost",//"零件费合计",
    "Total Receivable Amount": "Total Receivable Amount",// "应收合计",
    "Total Received Amount": "Total Received Amount",// "已收合计",
    "Paid Amount": "Paid Amount",
    "Total amount": "Total amount",
    "Purchase Return Qty": "Purchase Return Qty",//"采退数量"
    "Payment status": "Payment status",//"支付状态"
    "Amount after discount": "Amount after discount",//"折后单价"
    "Write off time": "Write off time",//"核销时间"
    "Financial audit": "Financial audit",//"财务审核",
    "Reviewed by Chief Supervisor": "Reviewed by Chief Supervisor",//"总经理审核"
    "Document is not in pending approval status": "Document is not in pending approval status",//"单据不是待审核状态",
    "Financial audit completed": "Financial audit completed",//"财务审核完成",
    "Financial audit failed": "Financial audit failed",//"财务审核失败",
    "Manager approval failed": "Manager approval failed",//"经理审核失败",
    "Manager review succeeded": "Manager review succeeded",//"经理审核成功",
    "The document is not in financial approved status": "The document is not in financial approved status",//"单据不是财务已审核状态"
    "Document is not in completed status":"Document is not in completed status",//"单据不是已完成状态"

}
export default en_US